import { ILocation } from '../types/location';

export const DEFAULT_REGION: ILocation = {
  id: 1,
  displayName: 'Москва',
};

export const SPECIAL_REGIONS = [
  {
    id: 1,
    displayName: 'Москва',
  },
  {
    id: 2,
    displayName: 'Санкт-Петербург',
  },
  {
    id: 4593,
    displayName: 'Московская область',
  },
  {
    id: 4588,
    displayName: 'Ленинградская область',
  },
];
